import { frontendURL } from 'dashboard/helper/URLHelper';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const CustomViewsSettings = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/custom-views'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'custom_views_settings_list',
          component: CustomViewsSettings,
          meta: {
            permissions: ['administrator', 'supervisor', 'cx_engineer'],
          },
        },
      ],
    },
  ],
};
